<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="昵称" prop="nickName">
              <a-input v-model="formInline.nickName" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="用户手机号" prop="password">
              <a-input v-model="formInline.phone" placeholder="请输入">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="所属门店" prop="store">
              <a-select
                default-value="lucy"
                style="width: 120px"
                @change="handleChange"
                v-model="formInline.store"
              >
                <a-select-option value="jack">全部</a-select-option>
                <a-select-option value="lucy">西乡店</a-select-option>
                <a-select-option value="disabled"> 宝安店 </a-select-option>
                <a-select-option value="Yiminghe"> 朱海店 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" html-type="submit"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <userDalanceContent
          ref="aaa"
          :formInline="formInline"
        ></userDalanceContent>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import userDalanceContent from "./userDalanceContent.vue";
export default {
  components: {
    userDalanceContent,
  },
  data() {
    return {
      formInline: {
        nickName: "",
        phone: "",
      },
    };
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
      this.$refs.aaa.query();
    },
    resetForm() {
      this.$refs.aaa.getUserListData();
      this.formInline.nickName = "";
      this.formInline.phone = "";
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/financialManagement/userDalance/userDalance.vue